import { ISignature, SignatureType } from "@evennt-tech/api-v2-core";
import { RawAttachmentFile } from "ts/api/attachmentFile";

export enum ViewModeEnum {
  saved = "saved",
  new = "new",
}

export type ViewModes = {
  saved?: boolean;
  new?: boolean;
};

export interface ICreateSignaturePublicReq {
  type: SignatureType;
  showId: string;
  name: string;
  role: string;
  file: RawAttachmentFile;
  shouldBeShownInList?: boolean;
  text?: string;
}

export type SignTaskModalProps = {
  taskTitle: string;
  showId: string;
  signatures: ISignature[];
  createSignature: (
    data: ICreateSignaturePublicReq
  ) => Promise<ISignature | undefined>;
  viewModes?: ViewModes;
  onClose: () => void;
  onSubmit: (selectedSignatureId?: string) => void;
};
